import { Uuid } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

export type FixedRouteSimple = {
  id: number;
  name: string;
};

export const fixedRouteSimpleSerializers = MSerializers.object<FixedRouteSimple>({
  id: MSerializers.integer,
  name: MSerializers.string,
});

export type FixedRouteFilters = {
  userId: number | undefined;
};
